const isDev = process.env.NODE_ENV === 'development'

function parseBooleanEnv(value: string | undefined, fallback: boolean): boolean {
  if (value === undefined) return fallback
  return ['1', 'true', 'yes', 'on'].includes(value.toLowerCase())
}

export const config = {
  /** Backend base URL (used server-side / route handlers) */
  apiBaseUrlBE: process.env.NEXT_PUBLIC_API_BASE_URL_BE || 'https://www.camplus.it',
  /** Frontend base URL (used client-side) */
  apiBaseUrlFE: process.env.NEXT_PUBLIC_API_BASE_URL_FE || 'https://www.camplus.it',
  /** Feature flag sent in root payload of /admissions/save */
  admissionsSaveTest: parseBooleanEnv(process.env.NEXT_PUBLIC_ADMISSIONS_SAVE_TEST, true),
  /** Aquisgrana REST prefix */
  apiPrefix: '/wp-json/aquisgrana/v1',

  /** Resolved base URL depending on context */
  get baseUrl() {
    const origin = isDev ? this.apiBaseUrlBE : this.apiBaseUrlFE
    return `${origin}${this.apiPrefix}`
  }
}
